import { Row, Input,InputNumber} from "antd";
import { useState, useEffect } from "react";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
export const InputCustomNumber = ({
  idCampo,
  nombreCampo,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
  step,
  min,
  max
}) => {
  // const [value, setValue] = useState();
  const [showPassword, setShowPassword] = useState(false);
    // Función para alternar la visibilidad de la contraseña
    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };
  
  // console.log("onChange prop:", onChange)
  let esRequired = required ? "*" : "";

  // useEffect(() => {
  //   setValue(elValue !== "" ? elValue : undefined);
  // }, [elValue]);
  // const handleInputChange = (e) => {
  //   console.log(e)
  //   const { id, value } = e.target;
  //   setValue(value); // Actualiza el estado local con el nuevo valor
  //   onChange({ target: { value: value, id: id } }); // Simula un evento y pasa el nuevo valor a la función onChange
  // };
  return (
    <Row justify={"left"}>
      <label htmlFor={idCampo}>
        <p className="nombre-campo">
          {nombreCampo} {esRequired}
        </p>
      </label>
      
      <Input
        className="input-component"
        autoComplete="none"
        id={idCampo}
        type="number"
        min={min}
        max={max}
        step={step}
        placeholder={elPlaceholder}
        onChange={onChange}
        value={elValue}
        required={true}
        status={tipoError}
      />
      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};
